import { render } from "./call.vue?vue&type=template&id=422edf9b&scoped=true&ts=true"
import script from "./call.vue?vue&type=script&lang=ts"
export * from "./call.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=422edf9b&lang=scss&scoped=true"

import exportComponent from "/Users/ls/Documents/维思英才/webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422edf9b"]])

export default __exports__